module.exports = {
	"Browser Check": {
		"Supported": "You're using a supported browser.",
		"Unsupported": "For the best experience, IDLA recommends [Chrome](https://www.google.com/chrome/) or [Firefox](https://support.mozilla.org/en-US/products/firefox) browser. Click the browser name to download either of these supported browers. Once you have Chrome or Firefox on your computer you can continue the rest of the check."
	},
	"JavaScript Check": {
		"Pass": "",
		"Failure": {
			"Chrome": "Refer to [Google support](https://support.google.com/adsense/answer/12654?hl=en) to enable JavaScript on your browser.",
			"Firefox": "Refer to [Mozilla support](https://support.mozilla.org/en-US/questions/1132243) to enable JavaScript on your browser.",
			"Default": "The browser you are using isn't a recommended broswer. Please refer to your browser's guide to enable JavaScript or download one of the recommended broswers."
		}
	},
	"Cookie Check": {
		"Pass": "",
		"Failure": {
			"Chrome": "Refer to [Google support](https://support.google.com/adsense/answer/35730?hl=en&ref_topic=1307496) to enable cookies in your browser.",
			"Firefox": "Refer to [Mozilla support](https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences) to enable cookies in your browser.",
			"Default": "The browser you are using isn't a recommended broswer. Please refer to your browser's guide to enable cookies or download one of the recommended broswers"
		}
	},
	"Popup Window Check": {
		"Pass": "",
		"Failure": {
			"Chrome": "Refer to [Google support](https://support.google.com/chrome/answer/95472?hl=en&co=GENIE.Platform=Desktop) to allow popup windows.",
			"Firefox": "Refer to [Mozilla support](https://support.mozilla.org/en-US/kb/pop-blocker-settings-exceptions-troubleshooting) to allow popup windows.",
			"Default": "The browser you are using isn't a recommended broswer. Please refer to your browser's guide to enable allow popup windows or download one of the recommended broswers"
		}
	},
	"Port 80 Check": {
		"Pass": "",
		"Failure": "Contact your network administrator about this error or call technical support at 1-800-927-8158."
	},
	"Adobe Flash": {
		"Pass": "",
		"Failure": "Refer to [Adobe support](https://get.adobe.com/flashplayer/) to download Flashplayer."
	},
	"Download Test": {
		"Pass": "Your download speed is fast.",
		"Failure": "Your download speed is slow. This might affect the ability to download files in your class. Try ways to increase your internet speed such as using a wire to connect instead of wifi."
	},
	"Upload Test": {
		"Pass": "Your upload speed is fast.",
		"Failure": "Your upload speed is slow. This might affect the ability to upload assignment files to your class . Try ways to increase your internet speed such as using a wire to connect instead of wifi."
	},
	"Latency Test": {
		"Pass": "Your internet connection speed is good.",
		"Failure": "Your internet is running slowly.  This might cause your class to timeout and not load properly. Try ways to increase your internet speed such as using a wire to connect instead of wifi."
	},
	"Jitter Test": {
		"Pass": "You don't have to worry about jitter.",
		"Failure": "You have high jitter which might affect your audio or video during live streaming such as eTutoring or IdahoLive event."
	}
};


//////////////////
// WEBPACK FOOTER
// ./app/localization/en-US.yaml
// module id = 124
// module chunks = 0